import React, { useState } from "react";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Table,
} from "antd";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import TreeMultiSelect from "../../../../components/common/TreeSelect";

import { chargesTableData, glAccounts, payers } from "../../../../data/accounting";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import { FaDollarSign } from "react-icons/fa";

import "./Invoices.css";
import { useNavigate } from "react-router-dom";

const ReceivableInvoiceRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Tenant Receipt", "1", "", "", "/accounting/receivables_payments/reciepts/tenant_receipts/new"),
    RightBarMethod("Homeowner Receipt", "2", "", "", "/accounting/receivables_payments/reciepts//HomeownerReceipt"),
    RightBarMethod("Other Receipt", "3", "", "", "/accounting/receivables_payments/reciepts/otherReceipt"),
    RightBarMethod("Application Fee", "5", "", "", "/accounting/receivables_payments/reciepts/newapplicationfee"),
    RightBarMethod("Tenant Charge", "6", "", "", "/accounting/receivables_payments/invoices/tenantcharge"),
    RightBarMethod("Homeowner Charge", "7", "", "", "/accounting/receivables_payments/invoices/homeownercharge"),
    RightBarMethod("Bulk Charges & Credits", "8", "", "", "/accounting/receivables_payments/invoices/bulkchargesandcredits"),
    RightBarMethod("Bulk Recurring Charges", "9", "", "", "/accounting/receivables_payments/invoices/bulkrecurringcharges"),
    RightBarMethod("Tenant Credit", "10", "", "", "/accounting/receivables_payments/invoices/newtenantcredit"),
    RightBarMethod("Homeowner Credit", "11", "", "", "/accounting/receivables_payments/invoices/newhomeownercredit"),
    RightBarMethod("Apply Credits", "12", "", "", "/accounting/receivables_payments/reciepts/applycredits"),
    RightBarMethod("Common Charge", "13", "", "", "/accounting/receivables_payments/invoices/NewCommonCharge"),
    RightBarMethod("Charge Late Fees", "14", "", "", "/accounting/receivables_payments/chargelatefees"),
    RightBarMethod("New Bank Deposit", "15", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),
    RightBarMethod("Lockbox", "16", "", "", "/accounting/receivables_payments/lockbox"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Tenant Payment Plan", "17", "", "", "/"),
      RightBarMethod("Homeowner Payment Plan", "18", "", "", "/"),
    ]
  ),
];

function Invoices() {

  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Payer",
      dataIndex: "payer",
      key: "payer",
      sorter: (a, b) => a.payer.length - b.payer.length,
      sortOrder: sortedInfo.columnKey === "payer" ? sortedInfo.order : null,
    },
    {
      title: "GL Account",
      dataIndex: "glAccount",
      key: "glAccount",
      sorter: (a, b) => a.glAccount.length - b.glAccount.length,
      sortOrder: sortedInfo.columnKey === "glAccount" ? sortedInfo.order : null,
    },
    {
      title: "Property-Unit",
      dataIndex: "propertyUnit",
      key: "propertyUnit",
      sorter: (a, b) => a.propertyUnit.length - b.propertyUnit.length,
      sortOrder:
        sortedInfo.columnKey === "propertyUnit" ? sortedInfo.order : null,
    },
    {
      title: "Charge Date",
      dataIndex: "chargeDate",
      key: "chargeDate",
      sorter: (a, b) => a.chargeDate.length - b.chargeDate.length,
      sortOrder: sortedInfo.columnKey === "chargeDate" ? sortedInfo.order : null,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
      sortOrder: sortedInfo.columnKey === "amount" ? sortedInfo.order : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
    },
  ];

  return (
    <>
      <div className="charges">
        <PageHeading heading="Charges" />
        <Row>
          <Col span={24}>
            <FilterContainer heading={"Filter charges with the options below."}>
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Units">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by units"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Select
                        options={[
                          { value: "Show Active Properties" },
                          { value: "Show All Properties" },
                          { value: "Show Hidden Properties" },
                        ]}
                        defaultValue="Show Active Properties"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payers">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by Payers"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="GL Accounts">
                      <TreeMultiSelect
                        options={[]}
                        placeholder="Select GL Account"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Amount">
                      <InputNumber
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Invoice Number">
                      <Input placeholder="Search by invoice number" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="From" required>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row justify="center">
        <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/receivables_payments/invoices/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReceivableInvoiceRightBar} />
      </div>
    </>
  );
}

export default Invoices;
